import { render } from "./ActionsMenu.vue?vue&type=template&id=b6fdb8e0&ts=true"
import script from "./ActionsMenu.vue?vue&type=script&lang=ts"
export * from "./ActionsMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__